jQuery(function(){
    let winWidth = window.innerWidth
    let vh = window.innerHeight * 0.01;
    let ctaConfigWrapper = jQuery('.cta-config');
    let productImg = jQuery('.cta-config .product-img');
    let text = jQuery('.cta-config .text');
    let maxDeltaX = 50;
    let maxDeltaY = 50;
    document.documentElement.style.setProperty('--vh', `${vh}px`);

    let wrapperWidth = jQuery('.cta-config').outerWidth();
    let wrapperHeight = jQuery('.cta-config').outerHeight();

    ctaConfig();

    function ctaConfig() {
      if(winWidth > 1024) {
        ctaConfigWrapper.on("mousemove", function(e) {
          let mouseX = e.pageX / wrapperWidth * 0.1;
          let mouseY = e.pageY / wrapperHeight * 0.1;
          let translateX = -((mouseX * maxDeltaX)+maxDeltaX);
          let translateY = -((mouseY * maxDeltaY)+maxDeltaY);
          productImg.css('transform', 'translate('+translateX+'%, '+translateY+'%)');
          productImg.css('transition', 'none');

          text.css('transform', 'translate('+translateX+'%, '+translateY+'%)');
          text.css('transition', 'none');
        })

        ctaConfigWrapper.on("mouseleave", function() {
          productImg.css('transform', 'translate(-50%, -50%)');
          productImg.css('transition', 'all 0.3s ease-in-out');

          text.css('transform', 'translate(-50%, -50%)');
          text.css('transition', 'all 0.3s ease-in-out');
        })
      }
    }
  }
)
